import type { Strings } from './strings.js';

export const ro: Strings = {
  languageName: 'Română',
  welcome: 'Bine ați venit',
  chooseReason: 'Cum vă putem ajuta?',
  back: 'Înapoi',
  cancel: 'Anulare',
  next: 'Continuare',
  submit: 'Trimite înregistrarea',
  submitting: 'Se trimite',
  yourDetails: 'Datele dumneavoastră',
  optional: 'opțional',
  required: 'câmp obligatoriu',
  requiredHint: 'Vă rugăm să completați câmpurile marcate.',
  fieldRequired: 'Vă rugăm să completați acest câmp.',
  fieldInvalid: 'Vă rugăm să verificați această informație.',
  pleaseSelect: 'Vă rugăm să alegeți',
  search: 'Căutare',
  noResults: 'Niciun rezultat',
  noOptions: 'Momentan nu există opțiuni disponibile aici. Vă rugăm să vă adresați unui coleg.',
  stepReason: 'Motivul vizitei',
  stepDetails: 'Date',
  stepDone: 'Gata',
  thankYou: 'Vă mulțumim!',
  submitted: 'Înregistrarea dumneavoastră a fost transmisă.',
  waitHint: 'Vă rugăm să luați loc. Veți fi chemat în curând.',
  scanFormHint: 'Scanați codul cu telefonul pentru a lua formularul cu dumneavoastră.',
  ticketNumber: 'Numărul dumneavoastră de așteptare este',
  queuedTitle: 'Vă mulțumim!',
  queuedHint: 'Înregistrarea a fost salvată și va fi transmisă automat. Vă rugăm să luați loc.',
  errorTitle: 'Din păcate nu a funcționat',
  errorHint: 'Vă rugăm să încercați din nou sau să vă adresați unui coleg.',
  tryAgain: 'Încercați din nou',
  startOver: 'Începeți din nou',
  closedTitle: 'Administrația noastră este momentan închisă',
  closedHint: 'Vă puteți înregistra oricum - vă contactăm în următoarea zi lucrătoare.',
  closedCallUs: 'Ne puteți contacta telefonic la',
  continueAnyway: 'Înregistrare oricum',
  appointmentQuestion: 'Aveți o programare?',
  appointmentYes: 'Da, am o programare',
  appointmentNo: 'Nu, nu am programare',
  visitingWhom: 'Pe cine doriți să vizitați?',
  privacyTitle: 'Protecția datelor',
  privacyAccept: 'Am citit nota de confidențialitate.',
  privacyRequired: 'Vă rugăm să confirmați nota de confidențialitate.',
  offline: 'Offline',
  offlineHint: 'Fără conexiune - înregistrările sunt salvate și trimise ulterior.',
  pendingCount: 'înregistrări salvate',
  idleWarning: 'Datele introduse vor fi șterse în scurt timp.',
  pairTitle: 'Conectare tabletă',
  pairHint: 'Vă rugăm să introduceți codul de asociere primit de la administrație.',
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'Conectare',
  pairError: 'Codul este invalid sau a expirat.',
  pairSuccess: 'Tabletă conectată',
  loading: 'Se încarcă',
  notConfigured: 'Niciun tip de vizită configurat',
  notConfiguredHint: 'Vă rugăm să vă adresați unui coleg.',
  adminLink: 'Administrare',
  pairCodeHint:
    'Codul este generat în administrare la „Locații și tablete” și este valabil doar o perioadă limitată.',
  setupTitle: 'Încă neconfigurat',
  setupText:
    'Acest sistem nu a fost încă configurat. Asistentul creează administratorul, organizația, o locație și prima tabletă.',
  setupButton: 'Pornește configurarea',
  setupAfter: 'După aceea, câmpul pentru codul de asociere apare aici automat.',
};
